const _ = require('lodash');

const jsRender = _.template(
	`
// AUTO GENERATED
// DO NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Icon = require("<%= ComponentPath %>");
const svg = require("<%= SVGPath %>");
const Component = (props) => {
    return (React.createElement(Icon.default, Object.assign({ }, props, { name: svg.default.id, size: <%= Size %> })));
};
Component.info = {
    id: svg.default.id,
    name: "<%= Name %>",
    size: <%= Size %>,
    getElement() {
        return svg.default.content.replace("<symbol", "<svg").replace("symbol>", "svg>");
    }
};
exports.default = Component;
`.trim()
);

module.exports = jsRender;
